module.exports = __webpack_public_path__ + "static/media/profilebtnedit.97561e6b.svg";